import React, { useEffect, useState } from 'react';
import { IDataSource } from 'app/concierge/types';
import { Box, Stack } from '@mui/material';
import IconHandler from 'components/common/icon/IconHandler';
import { conciergeAPI, ITileInfoData } from 'api/concierge';
import { TileInfoIcon } from 'components/tile-info-icon';

interface IProps {
    dataSource: IDataSource;
}

export default function DataSource({ dataSource }: IProps) {
    const dataSources = dataSource.data_sources;
    const [tilesInfo, setTilesInfo] = useState<Record<number, ITileInfoData>>({});

    useEffect(() => {
        const withElementId = dataSources?.filter((s) => s.element_id != null) ?? [];
        if (!withElementId.length) return;

        let cancelled = false;
        const ids = withElementId.map((s) => `${s.element_id}_0`);
        conciergeAPI
            .getTilesInfo(ids)
            .then((tiles) => {
                if (cancelled) return;
                const map: Record<number, ITileInfoData> = {};
                tiles.forEach((tile) => {
                    if (tile.element_id != null) map[tile.element_id] = tile;
                });
                setTilesInfo(map);
            })
            .catch((error) => {
                console.error('[DataSource] Failed to fetch tiles info:', error);
            });

        return () => {
            cancelled = true;
        };
    }, [dataSources]);

    if (!dataSources?.length) {
        return null;
    }

    return (
        <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 1 }}>
            {dataSources.map((source, index) => {
                const tileInfo = source.element_id != null ? tilesInfo[source.element_id] : undefined;

                const chipContent = (
                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={0.5}
                        sx={{
                            pl: '6px',
                            pr: '8px',
                            gap: '8px',
                            height: '24px',
                            borderRadius: '6px',
                            background: 'rgba(34, 34, 34, 0.04)',
                            flexShrink: 0,
                        }}
                    >
                        <IconHandler
                            icon={{ type: source.icon_type, value: source.icon }}
                            sx={{ fontSize: '14px', flexShrink: 0 }}
                        />
                        <Box component="span" sx={{ fontSize: '12px', lineHeight: 1.4 }}>
                            {source.name}
                        </Box>
                    </Stack>
                );

                if (tileInfo) {
                    return (
                        <TileInfoIcon
                            key={index}
                            tile={tileInfo}
                            customFieldsDisplayOnTileInfo={tileInfo.customFieldsDisplayOnTileInfo}
                            anchor="wrapper"
                            placement="left-start"
                        >
                            {chipContent}
                        </TileInfoIcon>
                    );
                }

                return <React.Fragment key={index}>{chipContent}</React.Fragment>;
            })}
        </Stack>
    );
}
